// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import("@microApp/ApplicationBootstrap");
